<template>
  <div
    class="relative h-24px w-24px cursor-pointer"
    @mouseenter="showCartPreview = true"
    @mouseleave="showCartPreview = false"
  >
    <i class="icon-cart text-24px" />
    <p
      v-if="totalQuantity > 0"
      class="absolute h-12px w-12px flex items-center justify-center rounded-full bg-brand-deep-yellow text-10px text-white -right-2px -top-2px"
    >
      {{ totalQuantity }}
    </p>
    <CartPreview
      v-if="showCartPreview"
      class="absolute top-full -right-16px"
      :layout-type="layoutStore.isDesktop ? 'desktop' : 'mobile'"
    />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { ref } from 'vue'

import CartPreview from '@/components/CartPreview.vue'
import { useCartStore } from '@/store/cartStore'
import { useLayoutStore } from '@/store/layoutStore'

const layoutStore = useLayoutStore()

const { totalQuantity } = storeToRefs(useCartStore())
const showCartPreview = ref(false)
</script>
